var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_1013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.0566C28 21.7886 21.732 28.0566 14 28.0566C6.26801 28.0566 0 21.7886 0 14.0566C0 6.32465 6.26801 0.0566406 14 0.0566406C21.732 0.0566406 28 6.32465 28 14.0566ZM14.5017 10.3921C13.14 10.9584 10.4185 12.1307 6.3372 13.9088C5.67446 14.1724 5.32729 14.4302 5.29568 14.6823C5.24227 15.1084 5.77582 15.2762 6.50237 15.5046C6.6012 15.5357 6.7036 15.5679 6.80858 15.602C7.5234 15.8344 8.48495 16.1062 8.98482 16.117C9.43826 16.1268 9.94434 15.9399 10.5031 15.5562C14.3163 12.9821 16.2848 11.6811 16.4083 11.653C16.4955 11.6332 16.6164 11.6084 16.6982 11.6811C16.7801 11.7539 16.772 11.8917 16.7634 11.9286C16.7105 12.154 14.6161 14.1011 13.5323 15.1087C13.1944 15.4228 12.9547 15.6457 12.9057 15.6965C12.796 15.8105 12.6841 15.9184 12.5766 16.022C11.9125 16.6622 11.4146 17.1423 12.6042 17.9262C13.1759 18.3029 13.6333 18.6145 14.0897 18.9253C14.5882 19.2647 15.0853 19.6033 15.7285 20.0249C15.8924 20.1323 16.0489 20.2439 16.2014 20.3526C16.7814 20.7661 17.3025 21.1376 17.9463 21.0784C18.3204 21.044 18.7069 20.6922 18.9031 19.643C19.3669 17.1636 20.2786 11.7915 20.4892 9.57778C20.5077 9.38382 20.4845 9.1356 20.4658 9.02664C20.4472 8.91768 20.4082 8.76243 20.2666 8.6475C20.0988 8.5114 19.8399 8.4827 19.7241 8.48474C19.1975 8.49401 18.3896 8.77492 14.5017 10.3921Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_1013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.0566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramNegative);
export default __webpack_public_path__ + "static/media/telegram-negative.1ac1c4352f2c5b842a11ac393dd84ac8.svg";
export { ForwardRef as ReactComponent };